import Vue from 'vue';
const Locations = {
  state: {
    Locations: [],
    Custom: []
  },

  getters: {
    Locations(state) {
      return state.Locations;
    },
    CustomLocations(state){
      return state.Custom;
    }
  },

  mutations: {
    getLocations(state, payload) {
      state.Locations = payload;
    },
    getCustom(state, payload) {
      state.Custom = payload;
    },
  },

  actions: {
    getLocations(context, payload) {
      const url = 'Locations';
      Vue.prototype.$axios
        .get(url)
        .then(
          (res) => {
            let all = res.data.filter(i => {return i.UserID == null})
            //Only Non-User and Current User Data will be returned so we don't need to verify
            //the value of the UserID
            let custom = res.data.filter(i => { return i.UserID != null})
            context.commit('getLocations', all);
            context.commit('getCustom', custom);
          },
          (error) => {
            console.log(error);
          },
        );
    },
    updateLocations(context, payload){
      const url = `Locations/${ payload.id }`;
      Vue.prototype.$axios
        .put(url, payload)
        .then(
          (res) => {
            context.dispatch('getLocations')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    createLocations(context, payload){
      const url = `Locations`;
      Vue.prototype.$axios
        .post(url, payload)
        .then(
          (res) => {
            context.dispatch('getLocations')
          },
          (error) => {
            console.log(error);
          },
        );
    },
    deleteLocations(context, payload){
      const url = `Locations/${ payload.id }`;
      Vue.prototype.$axios
        .delete(url)
        .then(
          (res) => {
            context.dispatch('getLocations')
          },
          (error) => {
            console.log(error);
          },
        );
    }
  },
}

export default Locations